var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_8630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35627 0.41548L3.89159 3.51822L0.614589 4.01738C0.0269264 4.10643 -0.208587 4.86337 0.21758 5.29691L2.58841 7.71067L2.02767 11.1204C1.92673 11.7367 2.54804 12.1984 3.06841 11.9102L6 10.3002L8.93159 11.9102C9.45196 12.1961 10.0733 11.7367 9.97233 11.1204L9.41159 7.71067L11.7824 5.29691C12.2086 4.86337 11.9731 4.10643 11.3854 4.01738L8.10841 3.51822L6.64373 0.41548C6.38131 -0.137577 5.62093 -0.144607 5.35627 0.41548Z",
    fill: "#FD9B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_8630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 -0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/review_star.d7c4efbfe47e5a3780adc861d82f5431.svg";
export { ForwardRef as ReactComponent };